import type { Component, FutureGroup } from "./api";
import { COMPONENT_LABEL, COPY, money, ruleValue } from "./format";

export type FutureChangeFee = {
  component: Component;
  label: string;
  display: string;        // ruleValue(...) for a rule, money(...) for a projection or a fed value, COPY.futureFollows for a follow-on
  changed: boolean;
  note: string | null;    // "version N · note" for a rule, "origin · note" for a projection, null for a fed value
  marketplaceWide: boolean; // true when the engine applied a marketplace-wide rule
};
export type FutureChangeGroup = { effective_from: string; fees: FutureChangeFee[] };

// C5 v2.3 (PFC MASTER debt D11): the engine decides which fee is in force on each change date (C2 v1.15,
// future_resolution, the run's own lookups). This module only words what it serves; no precedence lives here.
export function displayFutureChanges(groups: FutureGroup[]): FutureChangeGroup[] {
  return groups.map((group) => ({
    effective_from: group.effective_from,
    fees: group.fees.map((fee) => ({
      component: fee.component,
      label: COMPONENT_LABEL[fee.component],
      display: fee.source === "follows" ? COPY.futureFollows : fee.source === "rule" ? ruleValue(fee) : money(fee.value, fee.currency),
      changed: fee.changed,
      note: fee.source === "rule"
        ? `version ${fee.version}${fee.note ? ` · ${fee.note}` : ""}`
        : fee.source === "projection" ? `${fee.origin} · ${fee.note}` : null,
      marketplaceWide: fee.scope === "marketplace",
    })),
  }));
}
